import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import { DeliveryIndicatorStatus } from '@spa/components/organisms/mypage/order/model/order-status-view/delivery-indicator'
import {
  alertOrderStatusView,
  noticeOrderStatusView,
  warningOrderStatusView,
} from '@spa/components/organisms/mypage/order/model/order-status-view/label-view'

/**
 * NP後払いの与信審査待ち
 * クレジットカードのことではないので注意
 * @see https://github.com/Everforth/growthpalette-front/pull/7903#discussion_r1510239572
 */
const waitingForCreditExamination: OrderStatusViewModel = {
  label: 'ご注文情報の与信審査中',
  labelView: noticeOrderStatusView,
  description: {
    forListView: 'ご注文情報の与信審査中はキャンセルできません。',
  },
  deliveryIndicatorStatus: DeliveryIndicatorStatus.IN_PREPARATION,
}

const beforePayment: OrderStatusViewModel = {
  label: 'ご入金待ち',
  labelView: alertOrderStatusView,
  description: {
    forListView: '決済が完了していません。ご確認ください。',
  },
}

const paymentDone: OrderStatusViewModel = {
  label: '注文完了（未発送）',
  labelView: noticeOrderStatusView,
  description: {
  },
  deliveryIndicatorStatus: DeliveryIndicatorStatus.IN_PREPARATION,
}

/**
 * TODO: OrderStatusViewとしてはpaymentDoneと区別する必要がないので適切な名前で統合する
 */
const beforePreparingShipping: OrderStatusViewModel = {
  label: '注文完了（未発送）',
  labelView: noticeOrderStatusView,
  description: {
  },
  deliveryIndicatorStatus: DeliveryIndicatorStatus.IN_PREPARATION,
}

/**
 * TODO: IN_PREPARATIONのインジケーター出したほうが良いかもしれない
 */
const shipmentSuspendPreparation: OrderStatusViewModel = {
  label: '出荷準備中',
  labelView: noticeOrderStatusView,
  description: {
  },
}

const preparingShipping: OrderStatusViewModel = {
  label: '出荷準備中',
  labelView: noticeOrderStatusView,
  description: {
  },
  deliveryIndicatorStatus: DeliveryIndicatorStatus.IN_PREPARATION,
}

const shipmentSuspendDelivery: OrderStatusViewModel = {
  label: '発送済み（調査中）',
  labelView: warningOrderStatusView,
  description: {
  },
}

const delivering: OrderStatusViewModel = {
  label: '発送済み',
  labelView: noticeOrderStatusView,
  description: {
    forListView: 'ご注文の商品を発送しました。',
  },
  deliveryIndicatorStatus: DeliveryIndicatorStatus.SHIPPED,
}

const shipmentUndeliverable: OrderStatusViewModel = {
  label: '発送済み',
  labelView: noticeOrderStatusView,
  description: {
  },
}

const paymentNotAccepted: OrderStatusViewModel = {
  label: '決済未完了',
  labelView: alertOrderStatusView,
  description: {
  },
}

/**
 * TODO: NPという決済方法に依存した語を削除する
 */
const npProfileErrorOccurred: OrderStatusViewModel = {
  label: '購入者情報エラー',
  labelView: alertOrderStatusView,
  description: {
  },
  /**
   * TODO:
   * 準備中ではなくユーザーのアクション待ち（アクションがなければキャンセル）なので、
   * 準備中のインジケーター表示はない方がよいかも
   */
  deliveryIndicatorStatus: DeliveryIndicatorStatus.IN_PREPARATION,
}

/**
 * TODO: NPという決済方法に依存した語を削除する
 */
const npCreditErrorOccurred: OrderStatusViewModel = {
  label: '与信エラー',
  labelView: alertOrderStatusView,
  description: {
  },
  /**
   * TODO:
   * 準備中ではなくユーザーのアクション待ち（アクションがなければキャンセル）なので、
   * 準備中のインジケーター表示はない方がよいかも
   */
  deliveryIndicatorStatus: DeliveryIndicatorStatus.IN_PREPARATION,
}

const errorOccurred: OrderStatusViewModel = {
  label: '決済エラー',
  labelView: alertOrderStatusView,
  description: {
  },
}

const reorderExpired: OrderStatusViewModel = {
  label: '再注文期限切れによりキャンセル',
  labelView: warningOrderStatusView,
  description: {
    forListView: '再注文の期限が過ぎたためキャンセルされました。',
    forDetailView: '再注文の期限が過ぎたためキャンセルされました。',
  },
}

const paymentExpired: OrderStatusViewModel = {
  label: '決済期限切れキャンセル',
  labelView: warningOrderStatusView,
  description: {
    forListView: '決済の期限が過ぎたためキャンセルされました。',
    forDetailView: '決済の期限が過ぎたためキャンセルされました。',
  },
}

/**
 * TODO: 現状使われていないかも
 */
const paymentAbandoned: OrderStatusViewModel = {
  label: '決済未完了のためキャンセル',
  labelView: warningOrderStatusView,
  description: {
    forListView: '決済手続きが完了しなかったためキャンセルされました。',
  },
}

const canceled: OrderStatusViewModel = {
  label: 'キャンセル',
  labelView: warningOrderStatusView,
  description: {
    forListView: 'ご注文の商品はキャンセルされました。',
  },
}

const others: OrderStatusViewModel = {
  label: 'その他',
  labelView: noticeOrderStatusView,
  description: {
  },
}

/**
 * TODO:
 * 旧OrderHistoryStatusをそのまま移植しているが、
 * OrderStatusViewの観点で統合・リネームするべきconstがあるので整理する
 */
export const orderStatusViewKinds: { [k: string]: OrderStatusViewModel } = {
  waitingForCreditExamination,
  beforePayment,
  paymentDone,
  beforePreparingShipping,
  shipmentSuspendPreparation,
  preparingShipping,
  shipmentSuspendDelivery,
  delivering,
  shipmentUndeliverable,
  paymentNotAccepted,
  npProfileErrorOccurred,
  npCreditErrorOccurred,
  errorOccurred,
  reorderExpired,
  paymentExpired,
  paymentAbandoned,
  canceled,
  others,
}
